// Tipos de material disponibles según la plataforma del post.
// Las claves coinciden con Platform.name y los valores con ContentPost.MATERIAL_TYPE_CHOICES.

export const MATERIAL_LABELS = {
  image: 'Imagen',
  video: 'Video',
  carousel: 'Carrusel',
  story: 'Historia',
  reel: 'Reel',
};

const TODOS = ['image', 'video', 'carousel', 'story', 'reel'];

const MATERIALES_POR_PLATAFORMA = {
  instagram: ['image', 'video', 'carousel', 'story', 'reel'],
  facebook: ['image', 'video', 'carousel', 'story', 'reel'],
  tiktok: ['video', 'carousel'],
  linkedin: ['image', 'video', 'carousel'],
  twitter: ['image', 'video'],
  pinterest: ['image', 'video', 'carousel'],
};

/**
 * Opciones [{value, label}] de tipo de material para una plataforma.
 * - Sin plataforma seleccionada: lista vacía.
 * - Plataforma desconocida: todos los tipos.
 * - `valorActual`: si el post ya tiene un tipo que la plataforma no admite
 *   (datos antiguos), se conserva para no perderlo al editar.
 */
export const materialesParaPlataforma = (plataformaNombre, valorActual = '') => {
  if (!plataformaNombre) return [];
  const permitidos = MATERIALES_POR_PLATAFORMA[String(plataformaNombre).toLowerCase()] || TODOS;
  const valores = valorActual && !permitidos.includes(valorActual) ? [...permitidos, valorActual] : permitidos;
  return valores.map(value => ({ value, label: MATERIAL_LABELS[value] || value }));
};

export const materialPermitido = (plataformaNombre, material) =>
  !material || materialesParaPlataforma(plataformaNombre).some(o => o.value === material);
